<template>
  <v-container fill-height justify-content-start class="app-section-width pa-0">
    <v-layout column>
      <v-layout
        flat
        class="activity-header"
        :class="{
          'success': status === activityReservationStatus.ACCEPTED || status === activityReservationStatus.SUCCESS_PAYMENT,
          'warning': status === activityReservationStatus.PENDING || status === activityReservationStatus.PROCESSING_PAYMENT,
        }"
      >
        <v-layout align-center>
          <v-icon
            :color="status === activityReservationStatus.ACCEPTED ? 'success-text' : 'warning-text'"
            class="ms-3 me-3 display-2"
          >
            {{
              status === activityReservationStatus.ACCEPTED || status === activityReservationStatus.SUCCESS_PAYMENT
                ? "mdi-check-circle-outline"
                : "mdi-clock-outline"
            }}
          </v-icon>
          <v-toolbar-title class="warning-text--text headline">
            {{
              status === activityReservationStatus.SUCCESS_PAYMENT ?
              $t('success.payment_completed') :
              status === activityReservationStatus.PROCESSING_PAYMENT ? 
              $t('error.title.processing_payment') :
              status === activityReservationStatus.ACCEPTED
                ? $t(`activity_reservation.complete.${reservationMethod.type}`)
                : $t("activity_reservation.pending")
            }}
          </v-toolbar-title>
        </v-layout>
      </v-layout>

      <v-layout column fill-height justify-center class="pa-5">
        <div
          v-if="status === activityReservationStatus.SUCCESS_PAYMENT"
          class="pb-10 text-center"
        >
          <h3 class="display-1">{{ $t('success.payment_completed') }}</h3>
        </div>

        <div
          class="subtitle-1 text-center"
          v-html="
            status === activityReservationStatus.SUCCESS_PAYMENT ?
            $t('activity_reservation.registered_reservation', { dashboardName: getDashboardName({ pageName: 'ACTIVITY_RESERVATIONS' })}) :
            status === activityReservationStatus.PROCESSING_PAYMENT ? 
            $t('error.text.processing_payment', { dashboardName: getDashboardName({ pageName: 'ACTIVITY_RESERVATIONS' })}) :
            status === activityReservationStatus.ACCEPTED
              ? $t('activity_reservation.visit_reservations_prompt', {
                  entityType: isRoomService
                    ? $t('activity_reservation.order')
                    : $t('activity_reservation.reservation'),
                  dashboardName: getDashboardName({
                    pageName: 'ACTIVITY_RESERVATIONS',
                  }),
                })
              : isRoomService
              ? $t('activity_reservation.confirmation_prompt_order')
              : $t('activity_reservation.confirmation_prompt_reservation')
          "
        ></div>
      </v-layout>

      <v-layout class="all-gap-10 pa-5" wrap>
        <v-flex>
          <v-btn
            @click="$router.push({ name: routeNames.main.name })"
            outlined
            block
            color="secondary"
          >
            {{ $t("activity_reservation.actions.browse_other_activities") }}
          </v-btn>
        </v-flex>

        <v-flex>
          <v-btn
            @click="
              $router.push({
                name: routeNames.activity_reservations.name,
                query: { reservationId: activityReservations.lastReservation || $route.params.activityReservationId },
              })
            "
            outlined
            block
            color="primary"
            class="primary-gradient"
          >
            {{
              $t("activity_reservation.actions.check", {
                entityType: isRoomService
                  ? $t("activity_reservation.order")
                  : $t("activity_reservation.reservation").toLowerCase(),
              })
            }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { activityReservationStatus } from '@/config'
import routeNames from '@/router/routes'

export default {
  beforeRouteEnter (to, from, next) {
    if (
      from.name !== routeNames.reservationSummary.name &&
      from.name !== routeNames.reservationCatalog.name &&
      from.name !== routeNames.catalogCategorySelection.name &&
      from.name !== routeNames.reservationError.name &&
      from.name !== routeNames.reservationPayment.name &&
      from.name !== routeNames.activity_reservations.name &&
      from.name !== routeNames.paymentMethods.name
    ) {
      next({ name: routeNames.main.name })
    } else {
      next()
    }
  },
  data () {
    return {
      routeNames,
      activityReservationStatus,
    }
  },
  computed: {
    ...mapGetters({
      reservationMethod: 'activityReservations/reservationMethod',
      getDashboardName: 'service/getDashboardName',
    }),
    ...mapState(['activityReservations']),
    status () {
      return this.$route.params.status ?
        this.$route.params.status :
        this.reservationMethod ?
          this.reservationMethod.autoAcceptReservation ?
            activityReservationStatus.ACCEPTED :
            activityReservationStatus.PENDING :
          null
    },
    isRoomService () {
      return (
        this.reservationMethod && this.reservationMethod.type === 'ROOM_SERVICE'
      )
    },
  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('reservationMethodType')
    next()
  },
}
</script>

<style scoped lang="scss">
.notranslate {
  transform: none !important;
}
.activity-header {
  max-height: 90px;
}
</style>
